import React from "react";

import listo_instrucciones from "../files/listo_instrucciones.pdf";

export default function PDF() {
    return <iframe src={listo_instrucciones} style={{height: '100vh', width: '100vw', border: 0}} /* loading="lazy" */ title="listo instrucciones"/>    
}
